(function () {
  'use strict';
  var details = document.querySelectorAll('[data-footer-details]');
  if (!details.length) return;
  var mobile = window.matchMedia('(max-width: 749px)');
  function sync() {
    details.forEach(function (item) {
      if (mobile.matches) item.removeAttribute('open');
      else item.setAttribute('open', '');
    });
  }
  sync();
  if (mobile.addEventListener) mobile.addEventListener('change', sync);
  else if (mobile.addListener) mobile.addListener(sync);
}());
